import { BrandingVm } from '@pf/shared-common';

export default {} as BrandingVm;
